type UpdateCallback = (newDuration: number) => void
type CompletedCallback = Function
type CountDownPromise = {
  onUpdate: ($onUpdate: UpdateCallback) => CountDownPromise
  onComplete: ($onComplete: CompletedCallback) => CountDownPromise
}

export type CountDown = {
  /**
   * 开始倒计时
   * @param duration 时间，秒数
   */
  (duration: number): CountDownPromise
  clear: Function
}

/**
 *
 * @param cover 是否覆盖上一次倒计时
 */
export function generateCountDown(cover: boolean = true): CountDown {
  let timer: number | undefined
  let duration: number = 0
  const clear = () => {
    if (timer !== undefined) clearInterval(timer)
  }
  const countDown: CountDown = (($duration: number = 60) => {
    clear()

    let $onUpdate: UpdateCallback
    let $onComplete: CompletedCallback
    const ret: CountDownPromise = {} as any
    const onUpdate = (callback: UpdateCallback) => {
      $onUpdate = callback
      return ret
    }
    const onComplete = (callback: CompletedCallback) => {
      $onComplete = callback
      return ret
    }
    ret.onUpdate = onUpdate
    ret.onComplete = onComplete
    cover && (duration = $duration)
    if (duration <= 0) {
      setTimeout(() => $onComplete && $onComplete(), 0)
      return ret
    }
    timer = setInterval(() => {
      if (duration > 0) {
        duration--
        $onUpdate && $onUpdate(duration)
      } else {
        clearInterval(timer)
        timer = undefined as any
        $onComplete && $onComplete()
      }
    }, 1000) as any
    return ret
  }) as any
  countDown.clear = clear
  return countDown
}
